// src/ListItem.js
import React from "react";
import "./ListItem.css";

const ListItem = ({ title, inspectionType, inspector, date }) => {
  let formattedDate = new Date(date).toLocaleDateString();
  return (
    <div className="list-item">
      <div className="list-item-content">
        <div className="list-item-title">{title}</div>
        <div className="list-item-description">{inspectionType}</div>
        <div className="list-item-inspector">{inspector}</div>
      </div>
      <div className="list-item-date">{formattedDate}</div>
    </div>
  );
};

const InspectionList = ({ items }) => {
  return (
    <React.Fragment>
      <div className="list-container">
        <div className="list-Item-heading">Recent Inspections</div>
        <div className="list-content scrollbar">
          {items.map((item, index) => (
            <ListItem key={index} title={item.title} inspectionType={item.inspectionType} inspector={item.inspector} date={item.date} />
          ))}
        </div>
      </div>
    </React.Fragment>
  );
};
export default InspectionList;



// WEBPACK FOOTER //
// ./src/components/Dashboard/ReVAMP_Dashboard/ReVAMPDashboardComponent/ListItem.jsx